import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Thead,
  Tbody,
  Flex,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import { FaTrash, FaEdit } from "react-icons/fa";
import EditYear from "../EditYear/EditYear";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ListAcademicYear = () => {
  const [academicYears, setAcademicYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useToast();

  useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/academic_year/list_year.php`,
          { params: { school_id: sessionStorage.getItem("school_id") } }
        );

        if (response.data.success) {
          setAcademicYears(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    // Initial fetch
    fetchAcademicYears();

    // Set interval to fetch the data every 1 second (1000ms)
    const interval = setInterval(fetchAcademicYears, 1000);

    // Cleanup the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  const handleDelete = async (id) => {
    const user_id = sessionStorage.getItem("user_id"); // Get user_id from sessionStorage

    try {
      const response = await axios.delete(
        `${BASE_URL}/admin/academic_year/delete_year.php`,
        {
          data: { id, user_id }, // Send data in request body
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data.success) {
        // Remove deleted row from state
        setAcademicYears((prev) => prev.filter((item) => item.id !== id));
        toast({
          title: "Success",
          description: "Academic year deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message || "Failed to delete academic year.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <TableContainer>
      <Table
        sx={{
          "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
        }}
      >
        <Thead>
          <Tr>
            <Th>Sr. No</Th>
            <Th>Academic Year</Th>
            <Th>Start Date</Th>
            <Th>End Date</Th>
            <Th>Status</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {academicYears.map((item, index) => (
            <Tr key={item.id}>
              <Td>{index + 1}</Td> {/* Serial Number */}
              <Td>{item.year_name}</Td>
              <Td>{item.start_date}</Td>
              <Td>{item.end_date}</Td>
              <Td>
                <Badge
                  borderRadius="full"
                  fontSize="10px"
                  colorScheme={item.status === 1 ? "green" : "green"}
                >
                  {item.status === 1 ? "Active" : "Active"}
                </Badge>
              </Td>
              <Td>
                <Flex align="center">
                  <EditYear id={item.id} />
                  <IconButton
                    icon={<FaTrash />}
                    size="sm"
                    colorScheme="red"
                    onClick={() => handleDelete(item.id)}
                    ml={2} // Add some margin to the left for spacing between the buttons
                  />
                </Flex>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default ListAcademicYear;
